// Website market split (/international = International, /uae = UAE agents; / routes by market).
export type SiteMarket = 'uae' | 'int';
export const SITE_MARKETS: readonly SiteMarket[] = ['uae', 'int'];

export const SITE_ROOT_PATH = '/';
export const UAE_PAGE_PATH = '/uae';
export const INTERNATIONAL_PAGE_PATH = '/international';

export const GEO_REDIRECT_COUNTRY = 'AE';

// An explicit International choice (cross-market link or "Outside the UAE"): /international stops sending AE IPs to /uae.
export const INTERNATIONAL_CHOICE_COOKIE = 'insiders_intl_choice';
export const INTERNATIONAL_CHOICE_QUERY = 'market=int';
export const INTERNATIONAL_CHOICE_MAX_AGE_S = 60 * 60 * 24 * 365;

export type SignupTrack = SiteMarket;
export type SignupPath = 'partner';

export const isSiteMarket = (value: unknown): value is SiteMarket =>
  typeof value === 'string' && (SITE_MARKETS as readonly string[]).includes(value);

export const isSignupPath = (value: unknown): value is SignupPath => value === 'partner';
